import React from 'react';

interface LayoutProps {
  className?: string;
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ className = '', children }) => {
  return <div className={` ${className}`}>{children}</div>;
};

interface SectionProps {
  className?: string;
  children: React.ReactNode;
}

const Header: React.FC<SectionProps> = ({ className = '', children }) => {
  return <div className={` ${className}`}>{children}</div>;
};

const Content: React.FC<SectionProps> = ({ className = '', children }) => {
  return <div className={` ${className}`}>{children}</div>;
};

export { Layout, Header, Content };
